import { GenericFieldFactory } from "../../Common/_generics/GenericFieldFactory";

export const IntegrationsSecondaryViewStore = GenericFieldFactory("INTEGRATIONS_SECONDARY_VIEW", null);